
import createIcon from "./createIcon";

export const Heading2Icon = createIcon('Heading2', (props) => {
  return (
    <svg {...props}>
      <path d="M15.21 5.37C15.21 6.32 14.73 7.28 13.49 8.61L11.46 10.79L15.39 10.79L15.39 12.05L9.52 12.05L9.52 11.03L12.33 7.99C13.43 6.79 13.82 6.1 13.82 5.42C13.82 4.63 13.23 4.1 12.36 4.1C11.59 4.1 10.97 4.59 10.61 5.44L9.44 4.89C9.89 3.62 10.97 2.85 12.4 2.85C14.06 2.85 15.21 3.86 15.21 5.37ZM2.26 6.73L6.7 6.73L6.7 3.02L8.05 3.02L8.05 12.05L6.7 12.05L6.7 8L2.26 8L2.26 12.05L0.9 12.05L0.9 3.02L2.26 3.02L2.26 6.73Z" fill={props.color} fillOpacity="1" fillRule="evenodd" />
    </svg >
  )
});
